<template>
  <div class="campaign-points-page">
    <app-page-header :title="[campaign.name, 'Pontos']" :loading="isLoading">
      <button @click="importPoints()" v-app-button.icon-left>
        <b-icon size="is-small" icon="upload"></b-icon>IMPORTAR
      </button>
      <router-link tag="button" to="create" v-app-button.icon-left>
        <b-icon size="is-small" icon="plus" />Novo
      </router-link>
      <button
        v-app-button.icon-left.clear
        v-app-back-button="{ name: 'campaign.index' }"
      >
        <b-icon size="is-small" icon="arrow-left" />Voltar
      </button>
    </app-page-header>

    <campaign-points-table
      ref="campaignPointsTable"
      :campaignId="campaignId"
    ></campaign-points-table>

    <b-modal
      :active.sync="showModal"
      has-modal-card
      trap-focus
      aria-role="dialog"
      aria-modal
    >
      <campaign-point-import-modal
        @success="onImportSuccess"
        :campaignId="campaignId"
      ></campaign-point-import-modal>
    </b-modal>
  </div>
</template>

<script>
import CampaignPointsTable from '@/components/Tables/CampaignPointsTable.vue';
import CampaignService from '@/services/campaign.service';
import CampaignPointImportModal from '@/components/Modals/CampaignPointImportModal.vue';

export default {
  name: 'campaign-points-page',
  components: {
    CampaignPointsTable,
    CampaignPointImportModal,
  },
  data: () => {
    return {
      showModal: false,
      campaignId: null,
      campaign: {},
      isLoading: true,
    };
  },
  methods: {
    loadCampaign(id) {
      CampaignService.getId(id)
        .then(({ data: campaign }) => (this.campaign = campaign))
        .finally(() => (this.isLoading = false));
    },
    importPoints() {
      this.showModal = true;
    },
    onImportSuccess() {
      this.$refs.campaignPointsTable.load();
    },
  },
  beforeMount() {
    this.campaignId = this.$route.params.campaignId;
    this.loadCampaign(this.campaignId);
  },
};
</script>
